module.exports = __webpack_public_path__ + "static/media/background.ea231622.png";